import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 40,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
  },
  wrapper: {
    display: 'flex',
    height: 400,
    flexWrap: 'wrap',
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
    },
  },
  videoContainer: {
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
  },
  video: {
    width: '100%',
    // height: 'auto',
    maxHeight: '100%',
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
    },
  },
  content: {
    paddingBlock: 16,
    paddingInlineEnd: 20,
    [theme.breakpoints.down('md')]: {
      paddingBlockStart: 0,
    },
  },
  title: {
    '& .MuiTypography-root': {
      fontWeight: 600,
      color: theme.palette.custom.main,
      paddingBlockEnd: 8,
    },
  },
  description: {
    '& .MuiTypography-root': {
      textOverflow: 'ellipsis',
    },
  },
  btn: {
    paddingBlock: 12,
  },
}))

export default useStyles
